import React, { Fragment, useState, useEffect } from "react";
import Select, { SingleValue } from "react-select";
import { FilterIcon, XIcon } from "@heroicons/react/outline";
import DropDownComponent from "../../questions/metadataDropDownList";
import {
  AddIcon,
  CollapseDownIcon,
  CollapseUpIcon,
  RemoveIcon,
  ResetIcon,
} from "../../../../assets/icons";
import { Disclosure, DisclosureButton } from "@headlessui/react";
import { connect } from "react-redux";
import {
  getSubjectByStateAndGrade,
  getStateAll,
  getGradeAll,
  getSubject,
} from "../../../../api/subject.service";
import {
  ILiftOffGalaxyStandard,
  ILiftOffGalaxyTopic,
} from "../../../../model/interface/liftOffGalaxyStandard";
import { IStandard } from "../../../../model/interface/standard";
import { getAllDomainsBySubject } from "../../../../api/domain.service";
import { getStandards } from "../../../../api/standard.service";
import { IDropDown } from "../../../../model/shared/dropDown";
import Loader from "../../../shared/loader/loader";
import {
  IStandardGroupDTO,
  IStandardGroupSearchRequest,
  IStandardGroupStandard,
  IStandardGroupStandardDTO,
  IStandardGroupStandardSearchRequest,
} from "../../../../model/interface/standardGroup";
import {
  getStandardGroups,
  getStandardGroupStandards,
} from "../../../../api/standardGroup.service";
import Constant from "../../../../utils/constant";
import { getLiftOffGalaxyStandard } from "../../../../api/liftOffGalaxyStandard.service";
import {
  DropdownItem,
  IReactSelect,
} from "../../../../model/interface/keyValuePair";

interface StandardGroupTabProps {
  liftOffHeaderId: number;
  liftOffGalaxyId: number;
  orderNumber: number;
  profile: any;
  handleAddTopic: (data: Array<ILiftOffGalaxyStandard>) => void;
  availableStates: Array<number>;
  availableGrades: Array<number>;
  selectedContentId: number;
}

const StandardGroupTab = (props: StandardGroupTabProps) => {
  const defaultPageNumber = 1;
  const defaultDropDownValue: DropdownItem = {
    label: "",
    value: "0",
  };

  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [gradeSubjects, setGradeSubjects] = useState<Array<IDropDown>>([]);
  const [domains, setDomains] = useState<Array<IDropDown>>([]);
  const [standards, setStandards] = useState<Array<IStandard>>([]);
  const [grades, setGrades] = useState<Array<IDropDown>>([]);
  const [groupName, setGroupName] = useState("");
  const [standardName, setStandardName] = useState("");
  const [toggle, setToggle] = useState<number>();
  const [standardGroups, setStandardGroups] = useState<
    Array<IStandardGroupDTO>
  >([]);
  const [groupedStandards, setGroupedStandards] = useState<
    Array<IStandardGroupStandardDTO>
  >([]);
  const [selectedStandardGroupIds, setSelectedStandardGroupIds] = useState<
    Array<number>
  >([]);
  const [states, setStates] = useState<Array<IDropDown>>([]);
  const [existingGalaxyStandards, setExistingGalaxyStandards] = useState<
    Array<ILiftOffGalaxyTopic>
  >([]);
  const [selectedState, setSelectedState] =
    useState<DropdownItem>(defaultDropDownValue);
  const [selectedGrade, setSelectedGrade] =
    useState<DropdownItem>(defaultDropDownValue);
  const [selectedSubject, setSelectedSubject] =
    useState<DropdownItem>(defaultDropDownValue);
  const [selectedDomain, setSelectedDomain] =
    useState<DropdownItem>(defaultDropDownValue);

  useEffect(() => {
    getExistingGalaxyStandards();
  }, []);

  useEffect(() => handleFilter(), []);

  useEffect(() => {
    if (states.length === 0) {
      bindStateData();
    }

    if (grades.length === 0) {
      bindGradeData();
    }

    if (selectedState.value !== "0" && selectedGrade.value !== "0") {
      bindSubjectsData();
    }

    if (selectedSubject.value !== "0") {
      bindDomainsData();
    }
  }, [selectedState.value, selectedGrade.value, selectedSubject.value]);

  const getExistingGalaxyStandards = () => {
    getLiftOffGalaxyStandard(
      props.liftOffHeaderId,
      props.liftOffGalaxyId,
      true,
      1,
      99999
    ).then((r) => {
      setExistingGalaxyStandards(r.data.data);
    });
  };

  const bindStateData = () => {
    async function stateReload() {
      setLoading(true);
      const response = getStateAll(100, 1);

      const data = (await response).data;
      let stateDDLData = data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.stateId,
        };
      });
      stateDDLData = stateDDLData.filter(
        (item) => props.availableStates.indexOf(item.value) !== -1
      );
      setStates(stateDDLData);
      setLoading(false);
    }
    stateReload();
  };

  const bindGradeData = () => {
    async function gradeReload() {
      setLoading(true);
      const response = getGradeAll(100, defaultPageNumber);

      const data = (await response).data;
      if (data.data.length > 0) {
        data.data.sort(
          (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
        );
        let dropdownData = data.data.map((eachGradeData) => {
          return {
            value: eachGradeData.gradeId || 0,
            label: `${eachGradeData.name}`,
          };
        });

        dropdownData = dropdownData.filter(
          (item) => props.availableGrades.indexOf(item.value) !== -1
        );

        setGrades(dropdownData);
      }

      setLoading(false);
    }
    gradeReload();
  };

  const bindSubjectsData = () => {
    async function subjectReload() {
      setLoading(true);
      const params = {
        name: "",
        contentAreaId: props.selectedContentId || 0,
        stateId: parseInt(selectedState.value) || 0,
        gradeId: parseInt(selectedGrade.value) || 0,
        gradeLevel: "",
        orderbyColumn: "name",
        sortDir: "asc",
        pageSize: 100,
        pageNumber: 1,
        isActive: true,
        isApproved: true,
        SubjectTypeId: Constant.SubjectType.PL,
      };

      const response = getSubject(params);
      const data = (await response).data;
      const subjectDDLData = data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.subjectId,
        };
      });
      setGradeSubjects(subjectDDLData);
      setLoading(false);
    }
    subjectReload();
  };

  const bindDomainsData = () => {
    setLoading(true);
    getAllDomainsBySubject(parseInt(selectedSubject.value), 100, 1).then(
      (res) => {
        const domainDDLData = res.data.data.map((values: any) => {
          return {
            label: values?.name,
            value: values?.domainId,
          };
        });
        setDomains(domainDDLData);
        setLoading(false);
      }
    );
  };

  const bindStandardData = () => {
    const standard: IStandard = {
      name: "",
      contentAreaId: "",
      subjectId: "",
      domainId: selectedDomain.value,
      code: "",
      isActive: true,
      description: "",
      loadOrder: 0,
      pageSize: 100,
      pageNumber: 1,
      orderbyColumn: "Name",
      sortDir: "ASC",
    };
    getStandards(standard).then((res: any) => {
      const standardData = res.data.data;
      setStandards(standardData);
    });
  };

  const handleGroupNameChange = (name: string) => {
    setGroupName(name);
  };

  const handleStandardNameChange = (name: string) => {
    setStandardName(name);
  };

  const handleStateChange = (state: SingleValue<DropdownItem> | null) => {
    if (state) {
      setSelectedState(state);
    }
  };

  const handleSubjectChange = (subject: SingleValue<DropdownItem> | null) => {
    if (subject) {
      setSelectedSubject(subject);
    }
  };

  const handleDomainChange = (domain: SingleValue<DropdownItem> | null) => {
    if (domain) {
      setSelectedDomain(domain);
    }
  };

  const handleGradeChange = (grade: SingleValue<DropdownItem> | null) => {
    if (grade) {
      setSelectedGrade(grade);
    }
  };

  const handleSetSelectedStandardGroups = (groupId: number) => {
    setSelectedStandardGroupIds((prev) => {
      if (prev.includes(groupId)) {
        return prev.filter((x) => x !== groupId);
      } else {
        return [...prev, groupId];
      }
    });
  };

  const handleFilter = () => {
    setLoading(true);
    const standard: IStandardGroupSearchRequest = {
      standardGroupId: 0,
      name: groupName,
      standardName: standardName,
      stateId: parseInt(selectedState.value),
      gradeId: parseInt(selectedGrade.value),
      subjectId: parseInt(selectedSubject.value),
      domainId: parseInt(selectedDomain.value),
      isActive: true,
    };

    getStandardGroups(standard, 1, 9999, "ASC", "StandardGroupId")
      .then((r) => {
        const response = r.data.data;

        if (response && response.length > 0) {
          const existingStandardGroupIds = existingGalaxyStandards?.map(
            (standard) => {
              if (standard.isStandardGrouped) {
                return standard.standardId;
              }
            }
          );

          const data = response.filter((group) => {
            return !existingStandardGroupIds.includes(group.standardGroupId);
          });

          setStandardGroups(data);
        }
        setStandardGroups(response);
        setLoading(false);
      })
      .catch((r) => {
        setLoading(false);
      });
  };

  const handleShowGroupedStandards = async (standardGroupId, index?, type?) => {
    setLoading(true);
    if (type === "show") {
      const groupStandardSearchReq: IStandardGroupStandardSearchRequest = {
        standardGroupId: standardGroupId,
        standardId: 0,
        isActive: true,
      };
      const response = getStandardGroupStandards(
        groupStandardSearchReq,
        1,
        99999
      );
      const data = (await response).data;

      setGroupedStandards(data.data);
      setToggle(index);
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  const validate = () => {
    let isValid = true;
    if (selectedStandardGroupIds.length === 0) {
      isValid = false;
    }
    return isValid;
  };

  const handleAddGroupedStandards = () => {
    if (validate()) {
      const liftOffGalaxyStandards: Array<ILiftOffGalaxyStandard> = [];
      selectedStandardGroupIds.map((standardGroupId, index) => {
        const liftOffGalaxyStandard: ILiftOffGalaxyStandard = {
          liftOffHeaderId: props.liftOffHeaderId,
          standardId: standardGroupId,
          liftOffGalaxyId: props.liftOffGalaxyId,
          orderNumber: props.orderNumber + index,
          isActive: true,
          isStandardGrouped: true,
          createdByUserId: props.profile?.userId,
          updatedByUserId: props.profile?.userId,
        };
        liftOffGalaxyStandards.push(liftOffGalaxyStandard);
      });
      props.handleAddTopic(liftOffGalaxyStandards);
      handleResetFilter();
    }
  };

  const handleResetFilter = () => {
    setGroupName("");
    setStandardName("");
    setResetDropdownFlag(!resetDropdownFlag);
    setGrades([]);
    setSelectedGrade(defaultDropDownValue);
    setSelectedState(defaultDropDownValue);
    setSelectedSubject(defaultDropDownValue);
    setSelectedDomain(defaultDropDownValue);
    setSelectedStandardGroupIds([]);
    setStandards([]);
  };

  return (
    <Fragment>
      {loading && <Loader />}
      <div className={" pb-6"}>
        <div
          className={
            "grid sm:grid-cols-4 md:grid-cols-8  xl:grid-cols-12 gap-4 text-sm"
          }
        >
          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>
              Group Name
            </div>
            <div className={"w-full mt-1"}>
              <input
                id="name"
                name="name"
                type="text"
                autoComplete="off"
                onChange={(e) => {
                  handleGroupNameChange(e.target.value);
                }}
                className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
              />
            </div>
          </div>

          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>
              Standard Name
            </div>
            <div className={"w-full mt-1"}>
              <input
                id="name"
                name="name"
                type="text"
                autoComplete="off"
                onChange={(e) => {
                  handleStandardNameChange(e.target.value);
                }}
                className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
              />
            </div>
          </div>

          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>State</div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedState}
                  onChange={handleStateChange}
                  options={states?.map((state) => ({
                    value: state.value.toString(),
                    label: state.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>Grade</div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedGrade}
                  onChange={handleGradeChange}
                  options={grades?.map((grade) => ({
                    value: grade.value.toString(),
                    label: grade.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>
              Subject
            </div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedSubject}
                  onChange={handleSubjectChange}
                  options={gradeSubjects?.map((gradeSubject) => ({
                    value: gradeSubject.value.toString(),
                    label: gradeSubject.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>
              Domain
            </div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedDomain}
                  onChange={handleDomainChange}
                  options={domains?.map((domain) => ({
                    value: domain.value.toString(),
                    label: domain.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <button
              className={`mt-6 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg
                   `}
              type="button"
              onClick={() => {
                handleFilter();
              }}
            >
              <FilterIcon className="w-3 h-3"></FilterIcon>
              Filter
            </button>
          </div>
        </div>

        <div id="dataContainer" className="mt-4">
          <div className="flex flex-col mt-1">
            <div className="-my-2  sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow  border-b border-gray-200 sm:rounded-lg">
                  <div className="flex flex-col h-60">
                    <div className="flex-grow overflow-auto rounded-lg">
                      <table className="relative  min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color sticky top-0">
                          <tr>
                            <th
                              scope="col"
                              className="w-10 sticky top-0 px-3 py-2font-light text-sm text-left text-white tracking-wider"
                            ></th>
                            <th
                              scope="col"
                              className="sticky top-0 px-3 py-2 w-1/3 font-light text-sm text-left text-white tracking-wider"
                            >
                              GroupId
                            </th>
                            <th
                              scope="col"
                              className="sticky top-0  px-3 py-2 font-light text-sm text-left text-white tracking-wider"
                            >
                              Name
                            </th>
                          </tr>
                        </thead>
                        <tbody className="z-10">
                          {standardGroups.map((group, index) => (
                            <Disclosure key={index}>
                              <>
                                <tr
                                  key={group.standardGroupId}
                                  className={
                                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                  }
                                >
                                  <td className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider">
                                    <div className="flex gap-2">
                                      <div>
                                        <input
                                          id={group.standardGroupId.toString()}
                                          name={group.standardGroupId.toString()}
                                          type="checkbox"
                                          checked={selectedStandardGroupIds.includes(
                                            group.standardGroupId
                                          )}
                                          onChange={(e) => {
                                            handleSetSelectedStandardGroups(
                                              group.standardGroupId
                                            );
                                          }}
                                          className="focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                                        />
                                      </div>
                                      <div className="">
                                        <DisclosureButton className="">
                                          {index !== toggle && (
                                            <CollapseDownIcon
                                              key={index}
                                              className={`w-5 h-5 text-gray-700`}
                                              onClick={(e) => {
                                                handleShowGroupedStandards(
                                                  group?.standardGroupId,
                                                  index,
                                                  "show"
                                                );
                                              }}
                                            />
                                          )}

                                          {index === toggle && (
                                            <CollapseUpIcon
                                              key={index}
                                              className={`w-5 h-5 text-gray-700`}
                                              onClick={(e) => {
                                                handleShowGroupedStandards(
                                                  group?.standardGroupId,
                                                  index,
                                                  "hide"
                                                );
                                              }}
                                            />
                                          )}
                                        </DisclosureButton>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                    <div className="mt-2 ml-2">
                                      {group.standardGroupId}
                                    </div>
                                  </td>

                                  <td className="px-3 py-2">{group.name}</td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <div
                                      className={`${
                                        index !== toggle ? "hidden" : ""
                                      } px-4 pt-4 pb-2 text-sm text-gray-500`}
                                    >
                                      <div className="shadow border rounded-lg">
                                        <table className="min-w-full">
                                          <thead>
                                            <tr className="bg-gray-50 border">
                                              <th
                                                scope="col"
                                                className="inline-flex items-center gap-2 px-3 py-2 pl-6 font-semibold text-gray-500 text-xs text-left tracking-wider"
                                              >
                                                <span className="flex gap-2">
                                                  StandardId
                                                </span>
                                              </th>
                                              <th
                                                scope="col"
                                                className="px-3 py-2 pl-6 text-sm text-left text-gray-500 font-semibold tracking-wider"
                                              >
                                                <span className="flex gap-2">
                                                  Code
                                                </span>
                                              </th>
                                              <th
                                                scope="col"
                                                className="px-3 py-2 pl-6 flex justify-center text-sm text-left text-gray-500 font-semibold tracking-wider"
                                              >
                                                <span className="flex gap-2">
                                                  Name
                                                </span>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody className="divide-y divide-gray-50">
                                            {groupedStandards.map(
                                              (standard, index) => (
                                                <tr key={index}>
                                                  <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                    {standard.standardId}
                                                  </td>
                                                  <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                    {standard.standardCode}
                                                  </td>
                                                  <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-center font-normal text-gray-500">
                                                    {standard.standardName}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>{" "}
                                    </div>
                                  </td>
                                </tr>
                              </>
                            </Disclosure>
                          ))}
                        </tbody>
                      </table>
                      {standardGroups.length === 0 && (
                        <p className="p-2">No Records Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end  mt-4">
          <button
            className={`mt-4 inline-flex items-center text-sm text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg
                  ${selectedStandardGroupIds.length > 0 ? "" : "opacity-50"}
                  `}
            type="button"
            onClick={() => {
              handleAddGroupedStandards();
            }}
          >
            Add Standard Group
          </button>
          <button
            type="button"
            className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
            onClick={() => {
              handleResetFilter();
            }}
          >
            <ResetIcon className="w-3 h-3"></ResetIcon>
            <span>Reset Filter</span>
          </button>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(StandardGroupTab);
